// This file is auto-generated by scripts/generate-models.ts
// Do not edit manually - run 'npm run generate-models' to update

import type { Model } from "../types.ts";

export const MINIMAX_MODELS = {
	"MiniMax-M2.7": {
		id: "MiniMax-M2.7",
		name: "MiniMax-M2.7",
		api: "anthropic-messages",
		provider: "minimax",
		baseUrl: "https://api.minimax.io/anthropic",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.3,
			output: 1.2,
			cacheRead: 0.06,
			cacheWrite: 0.375,
		},
		contextWindow: 204800,
		maxTokens: 131072,
	} satisfies Model<"anthropic-messages">,
	"MiniMax-M2.7-highspeed": {
		id: "MiniMax-M2.7-highspeed",
		name: "MiniMax-M2.7-highspeed",
		api: "anthropic-messages",
		provider: "minimax",
		baseUrl: "https://api.minimax.io/anthropic",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.6,
			output: 2.4,
			cacheRead: 0.06,
			cacheWrite: 0.375,
		},
		contextWindow: 204800,
		maxTokens: 131072,
	} satisfies Model<"anthropic-messages">,
	"MiniMax-M3": {
		id: "MiniMax-M3",
		name: "MiniMax-M3",
		api: "anthropic-messages",
		provider: "minimax",
		baseUrl: "https://api.minimax.io/anthropic",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.3,
			output: 1.2,
			cacheRead: 0.06,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
} as const;
